/*
 * Русский перевод TechDocs: список документации, читалка, сборка.
 */
import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/core-plugin-api/alpha';
import { techdocsTranslationRef } from '@backstage/plugin-techdocs/alpha';

const techdocsRu = createTranslationMessages({
  ref: techdocsTranslationRef,
  full: false,
  messages: {
    'aboutCard.viewTechdocs': 'Документация',
    'notFound.title': 'Документация не найдена',
    'notFound.builderNote':
      "В конфигурации techdocs.builder не равен 'local', поэтому этот Backstage не собирает документацию сам. Убедитесь, что документацию проекта собирает и публикует внешний процесс (например, CI/CD), либо переключите techdocs.builder на 'local'.",
    'buildLogs.title': 'Сборка документации',
    'buildLogs.closeDrawer': 'Закрыть панель',
    'buildLogs.showBuildLogs': 'Показать логи сборки',
    'buildLogs.waitingForLogs': 'Ожидание логов…',
    'stateIndicator.initialBuild.message':
      'Документация открыта впервые и готовится. Следующие загрузки будут быстрее.',
    'stateIndicator.contentStaleRefreshing.message':
      'Готовится новая версия документации, она появится в ближайшее время.',
    'stateIndicator.contentStaleReady.message':
      'Доступна новая версия документации — обновите страницу.',
    'stateIndicator.contentStaleReady.refreshButton': 'Обновить',
    'stateIndicator.contentStaleError.message':
      'Сборка новой версии документации не удалась.',
    'redirectNotification.redirectNow': 'Перейти сейчас',
    'search.noResults': 'Ничего не найдено',
    'search.placeholder': 'Поиск по документации {{entityTitle}}',
    'readerPageHeader.owner': 'Владелец',
    'readerPageHeader.lifecycle': 'Стадия',
    'readerPageHeader.source': 'Исходники',
    'home.supportButton': 'Документация проектов платформы.',
    'pageWrapper.title': 'Документация',
    'pageWrapper.subtitle': 'Документация, доступная в {{orgName}}',
    'table.columns.document': 'Документ',
    'table.columns.owner': 'Владелец',
    'table.columns.kind': 'Вид',
    'table.columns.type': 'Тип',
    'table.header.actions': 'Действия',
    'table.toolbar.searchPlaceholder': 'Фильтр',
    'table.pagination.labelRowsSelect': 'строк',
    'table.body.emptyDataSourceMessage': 'Записей нет',
    'table.actions.copyDocsUrl': 'Скопировать ссылку на документацию',
    'table.actions.addToFavorites': 'В избранное',
    'table.actions.removeFromFavorites': 'Убрать из избранного',
    'table.emptyState.title': 'Документов нет',
    'table.emptyState.description':
      'Добавьте документацию в свой проект — как это сделать, описано в руководстве',
    'table.emptyState.docsButton': 'РУКОВОДСТВО',
    'table.title.all': 'Все',
    'error.couldNotLoad': 'Не удалось загрузить список документации.',
    'nav.title': 'Документация',
    'entityContent.title': 'Документация',
    'reader.settings': 'Настройки',
  },
});

export const techdocsTranslations = [
  createTranslationResource({
    ref: techdocsTranslationRef,
    translations: { ru: () => Promise.resolve({ default: techdocsRu }) },
  }),
];
